import { z } from "zod"

export const helpCenterArticleFormSchema = z.object({
	translationId: z.string().min(1, "Translation ID is required"),
	languageCode: z.string().min(1, "Language is required"),
	title: z.string(),
	summary: z.string(),
	content: z.string(),
	imageUrl: z.string().optional(),
	imageBlurhash: z.string().optional(),
})

export type HelpCenterArticleFormData = z.infer<
	typeof helpCenterArticleFormSchema
>

// Only the article row stores a hash, and it describes the article's own cover.
export function storedCoverBlurhash(
	article: { imageUrl?: string | null; imageBlurhash?: string | null },
	translation: { imageUrl?: string | null },
): string | undefined {
	const cover = translation.imageUrl ?? article.imageUrl
	if (!cover || cover !== article.imageUrl) return undefined
	return article.imageBlurhash ?? undefined
}
